<template>
  <div :class="['d2d-services-box columns', {loading: filters.loading || activeAirline.loading.indexOf(activeAirline.selectedCabin) > -1}]">

    <div class="service-head">
      <div :class="['sh-nav', {'justify-space-between':!isReturning}]" v-if="settings.customFlight">
        <div :class="['default-txt sh-nav-item sh-box', {'active':activeLeg === 'leg1' && booking.serviceLegHighlight}]" v-if="!Object.keys(leg1Selected).length">Select departing flight</div>
        <div v-else :class="['sh-nav-item sh-box', {'active':activeLeg === 'leg1' && (isReturning || (!isReturning && !Object.keys(leg1Selected).length)) && booking.serviceLegHighlight}]">
          <div class="d-flex sh-selected-top align-center justify-space-between">
            <div>
              <b class="sh-airport">
                {{ leg1Selected.flight[0].origin.AirportCode }}
                <i class="fas fa-plane"></i>
                {{ leg1Selected.flight[leg1Selected.flight.length - 1].destination.AirportCode }}
              </b>
              <span>{{ dateFormat(leg1Selected.flight[0].origin.DateTime) }}</span>
            </div>
            <div class="sh-price">
              <!-- ${{ parseFloat((leg1Selected.payment.totalWithMarkUp - otherLegPrice('leg1')).toFixed(2)) }} -->
              <span v-if="currency.code === 'USD' && totalPrice">${{ (leg1Selected.payment.totalWithMarkUp - otherLegPrice('leg1')).toFixed(2) }}</span>
              <span v-else-if="totalPrice">{{ applyCurrency(leg1Selected.payment.totalWithMarkUp - otherLegPrice('leg1'), true, true) }}</span>
            </div>
          </div>
          <div class="d-flex sh-selected-bottom align-center justify-space-between">
            <div>
              <img :src="leg1Selected.flight[0].logo" />
              <span class="sh-airline">{{ leg1Selected.flightName }}</span>
            </div>
            <a class="change-flight" @click="changeActiveLeg('leg1')">CHANGE</a>
          </div>
        </div>

        <!-- <i class="fas fa-chevron-right sh-nav-item" v-if="isReturning"></i> -->

        <div :class="['default-txt sh-nav-item sh-box', {'active':activeLeg === 'leg2' && booking.serviceLegHighlight}]" v-if="isReturning && !Object.keys(leg2Selected).length">Select returning flight</div>
        <div v-else-if="isReturning" :class="['sh-nav-item sh-box', {'active':activeLeg === 'leg2' && !Object.keys(leg2Selected).length && booking.serviceLegHighlight}]">
          <div class="d-flex sh-selected-top align-center justify-space-between">
            <div>
              <b class="sh-airport">
                {{ leg2Selected.flight[0].origin.AirportCode }}
                <i class="fas fa-plane"></i>
                {{ leg2Selected.flight[leg2Selected.flight.length - 1].destination.AirportCode }}
              </b>
              <span>{{ dateFormat(leg2Selected.flight[0].origin.DateTime) }}</span>
            </div>
            <div class="sh-price">
              <!-- ${{ parseFloat((leg2Selected.payment.totalWithMarkUp + otherLegPrice('leg2')).toFixed(2)) }} -->
              <span v-if="currency.code === 'USD' && totalPrice">${{ (leg2Selected.payment.totalWithMarkUp + otherLegPrice('leg2')).toFixed(2) }}</span>
              <span v-else-if="totalPrice">{{ applyCurrency(leg2Selected.payment.totalWithMarkUp + otherLegPrice('leg2'), true, true) }}</span>
            </div>
          </div>
          <div class="d-flex sh-selected-bottom align-center justify-space-between">
            <div>
              <img :src="leg2Selected.flight[0].logo" />
              <span class="sh-airline">{{ leg2Selected.flightName }}</span>
            </div>
            <a class="change-flight" @click="changeActiveLeg('leg2')">CHANGE</a>
          </div>
        </div>

        <!-- <i class="fas fa-chevron-right sh-nav-item" v-if="isReturning"></i> -->

        <!-- <div class="d-flex sh-continue align-center">
          <div class="sh-total-price" v-if="totalPrice">
            <div>Total Fare</div>
            <span v-if="totalPrice">
              <span v-if="currency.code === 'USD' && totalPrice">${{ totalPrice.toFixed(2) }}</span>
              <span v-else-if="totalPrice">{{ applyCurrency(totalPrice, true, true) }}</span>
            </span>
          </div>
          <div :class="['lr-btn continue-btn', {
            'active': (!isReturning && Object.keys(leg1Selected).length) || (isReturning && Object.keys(leg1Selected).length && Object.keys(leg2Selected).length),
            'secondary disabled': (!isReturning && !Object.keys(leg1Selected).length) || (isReturning && (!Object.keys(leg1Selected).length || !Object.keys(leg2Selected).length))
          }]" @click="continueToItinerary">
            Continue
          </div>
        </div> -->
      </div>

      <div class="d-flex align-center justify-space-between sort-line">
        <div class="sl-txt">Prices may change based on availability and are not final until you complete your purchase. You can review any additional fees before checkout.</div>

        <div class="rd-field-box">
          <label>Sort by</label>
          <select v-model="filters.sort">
            <option value="price-low-to-high">Price: low to high</option>
            <option value="price-high-to-low">Price: high to low</option>
          </select>
        </div>
      </div>
    </div>

    <transition-group mode="out-in" name="slide-up">
      <div :class="['d2d-service', {
        'not-available':!service.available,
        selected: selected[booking.activeLeg].token === service.token,
        disabled: (!isReturning && Object.keys(leg1Selected).length) || (isReturning && Object.keys(leg1Selected).length && Object.keys(leg2Selected).length),
        'showing-opt': showingFlightOptions === service.token
        }]"
        :disabled="!service.available"
        v-for="(service, i) in activeAirline.filtered[activeAirline.selectedCabin]" :key="i"
        v-show="servicesPage > i" :style="`--i: ${(i+1)%10 === 0 ? 10 : (i+1)%10}`"
        @click="showingFlightOptions !== service.token ? showingFlightOptions = service.token : showingFlightOptions = ''">
        <div class="d2d-service-mobile dx-flex align-stretch hide-in-mobile">
          <!-- <div class="justify-center mob-airline-logo">
            <img :src="service.flight[0].logo" />
          </div> -->
          <div class="flight-details">
            <div class="d-flex align-center fl-details">
              <div class="fd-logo">
                <img :src="service.flight[0].logo" />
                <transition name="slide-up">
                  <a class="cancel-options" v-show="showingFlightOptions === service.token && !isReturning"><i class="fas fa-times"></i></a>
                </transition>
              </div>
              <div class="flight-date">
                <b class="time">{{timeFormat(service.flight[0].origin.DateTime)}}</b>
                <div class="date">
                  <span>{{service.flight[0].origin.AirportCode}}</span>
                  &centerdot;
                  <span>{{dateFormat(service.flight[0].origin.DateTime)}}</span>
                </div>
              </div>
              <div class="flight-duration">
                <span class="duration">{{countDuration(service.flight)}}</span>
                <hr />
                <b>{{service.flight[0].airline.code}} {{service.flight[0].flightNo}}</b>
                {{countStop(service.flight)}}
                <div class="flight-layover" v-for="flData in service.flight" v-if="flData.layover">{{ durationFormat(flData.layover) }} layover in ({{ flData.origin.AirportCode }})</div>
              </div>
              <div class="flight-date">
                <b class="time">{{timeFormat(service.flight[service.flight.length - 1].destination.DateTime)}}</b>
                <div class="date">
                  <span>{{service.flight[service.flight.length - 1].destination.AirportCode}}</span>
                  &centerdot;
                  <span>{{dateFormat(service.flight[service.flight.length - 1].destination.DateTime)}}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="flight-price d-flex flex-column">
            <div class="price">
              <span v-if="isReturning && activeLeg === 'leg2'">+</span>
              <span v-if="service.available && currency.code === 'USD'">$ {{ (service.payment.totalWithMarkUp + otherLegPrice()).toFixed(2) }}</span>
              <span v-else-if="service.available && currency.code !== 'USD'">{{ applyCurrency(service.payment.totalWithMarkUp + otherLegPrice())}}</span>
              <span v-else>N/A</span>
            </div>
            <div class="per-traveler">
              <span v-if="isReturning">Roundtrip for</span>
              All Traveler(s)
            </div>
            <!-- <div :class="['op-btn btn-md btn-block btn-danger', {disabled: !service.available}]" @click="check(service)">
              <span v-if="service.available">
                <span v-if="booking.activeLeg === 'leg1'">Select Flight</span>
                <span v-else-if="booking.activeLeg === 'leg2'">Select Flight</span>
                <span v-else>Book Now</span>
              </span>
              <span v-else>--</span>
            </div> -->
          </div>
        </div>

        <div class="d2d-service-mobile dx-flex align-stretch hide-in-mobile" v-if="isReturning && !settings.customFlight">
          <div class="flight-details">
            <div class="d-flex align-center fl-details">
              <div class="fd-logo">
                <img :src="service.returnFlight[0].logo" />
                <a class="cancel-options" v-show="showingFlightOptions === service.token"><i class="fas fa-times"></i></a>
              </div>
              <div class="flight-date">
                <b class="time">{{timeFormat(service.returnFlight[0].origin.DateTime)}}</b>
                <div class="date">
                  <span>{{service.returnFlight[0].origin.AirportCode}}</span>
                  &centerdot;
                  <span>{{dateFormat(service.returnFlight[0].origin.DateTime)}}</span>
                </div>
              </div>
              <div class="flight-duration">
                <span class="duration">{{countDuration(service.returnFlight)}}</span>
                <hr />
                <b>{{service.returnFlight[0].airline.code}} {{service.returnFlight[0].flightNo}}</b>
                {{countStop(service.returnFlight)}}
                <div class="flight-layover" v-for="flData in service.flight" v-if="flData.layover">{{ durationFormat(flData.layover) }} layover in ({{ flData.origin.AirportCode }})</div>
              </div>
              <div class="flight-date">
                <b class="time">{{timeFormat(service.returnFlight[service.returnFlight.length - 1].destination.DateTime)}}</b>
                <div class="date">
                  <span>{{service.returnFlight[service.returnFlight.length - 1].destination.AirportCode}}</span>
                  &centerdot;
                  <span>{{dateFormat(service.returnFlight[service.returnFlight.length - 1].destination.DateTime)}}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="flight-price d-flex flex-column"></div>
        </div>

        <!-- <div class="flight-faretype hide-in-mobile" v-if="service.fareType && (!showingFlightOptions || showingFlightOptions !== service.token) && false">
          <label>Fare Type:</label>
          <b>{{ service.fareType }}</b>
        </div> -->

        <div class="flight-options-box" @click.stop>
          <i :class="['fas fa-chevron-left fa-2x f-prev-next', {disabled:flightOptionScroll.active === 0}]" @click="foScroll('left', service.options.length)"></i>

          <div class="flight-options hide-in-mobile" v-if="showingFlightOptions === service.token && apiType === 'API2'"  :style="{right: `${flightOptionScroll.style}px`}">
            <flight-option v-for="(flightOption, ix) in service.options" :key="ix"
              :flightOption="flightOption" :service="service"
              @check="check"
            ></flight-option>
          </div>

          <i :class="['fas fa-chevron-right fa-2x f-prev-next', {disabled:flightOptionScroll.active === service.options.length - 1}]" @click="foScroll('right', service.options.length)"></i>
        </div>
        <div class="proxy" style="position: absolute;visibility: hidden;">-{{ showingFlightOptions }}</div>
  
        <div class="service-mobile">
          <div class="d-flex justify-space-between s-mob-header">
            <img :src="service.flight[0].logo" />
            <div>
              <div class="price">
                <span v-if="isReturning && activeLeg === 'leg2'">+</span>
                <span v-if="service.available && currency.code === 'USD'">$ {{ (service.payment.totalWithMarkUp + otherLegPrice()).toFixed(2) }}</span>
                <span v-else-if="service.available && currency.code !== 'USD'">{{ applyCurrency(service.payment.totalWithMarkUp + otherLegPrice())}}</span>
                <span v-else>N/A</span>
              </div>
              <div class="per-traveler">
                <span v-if="isReturning">Roundtrip for</span>
                All Traveler(s)
              </div>
            </div>
          </div>
          <div class="serv-mob-details">
            <div class="d-flex flight-time align-center">
              <span>{{timeFormat(service.flight[0].origin.DateTime)}}</span>
              <hr />
              <span>{{timeFormat(service.flight[service.flight.length - 1].destination.DateTime)}}</span>
            </div>
            <div class="airport-row d-flex align-center">
              <span>{{service.flight[0].origin.AirportName}} ({{service.flight[0].origin.AirportCode}})</span>
              <span>-</span>
              <span>{{service.flight[service.flight.length - 1].origin.AirportName}} ({{service.flight[service.flight.length - 1].origin.AirportCode}})</span>
            </div>
            <div class="serv-mov-duration d-flex">
              <span>{{countDuration(service.flight)}}</span>
              <span>|</span>
              <b>{{service.flight[0].airline.code}} {{service.flight[0].flightNo}}</b>
              <span>{{countStop(service.flight)}}</span>
            </div>
            <div class="flight-layover" v-for="flData in service.flight" v-if="flData.layover">{{ durationFormat(flData.layover) }} layover in ({{ flData.origin.AirportCode }})</div>
          </div>
          <div class="serv-mob-details" v-if="isReturning && !settings.customFlight">
            <div class="d-flex flight-time align-center">
              <span>{{timeFormat(service.returnFlight[0].origin.DateTime)}}</span>
              <hr />
              <span>{{timeFormat(service.returnFlight[service.returnFlight.length - 1].destination.DateTime)}}</span>
            </div>
            <div class="airport-row d-flex align-center">
              <span>{{service.returnFlight[0].origin.AirportName}} ({{service.returnFlight[0].origin.AirportCode}})</span>
              <span>-</span>
              <span>{{service.returnFlight[service.returnFlight.length - 1].origin.AirportName}} ({{service.returnFlight[service.returnFlight.length - 1].origin.AirportCode}})</span>
            </div>
            <div class="serv-mov-duration d-flex">
              <span>{{countDuration(service.returnFlight)}}</span>
              <span>|</span>
              <b>{{service.returnFlight[0].airline.code}} {{service.returnFlight[0].flightNo}}</b>
              <span>{{countStop(service.returnFlight)}}</span>
            </div>
          </div>
          <transition name="slide-up">
            <a class="cancel-options" v-show="showingFlightOptions === service.token"><i class="fas fa-times"></i></a>
          </transition>
          <div class="flight-options" v-if="showingFlightOptions === service.token && apiType === 'API2'" @click.stop>

          <flight-option v-for="(flightOption, ix) in service.options" :key="ix"
            :flightOption="flightOption" :service="service"
            @check="check"
          ></flight-option>
        </div>
          <!-- <div class="lr-btn select-flight" @click="check(service)">Select Flight</div> -->
        </div>
      </div>
    </transition-group>

    <!-- <div class="d-flex align-center" style="margin-bottom: 100px">
      <div class="show-more" v-show="servicesPage < activeAirline.filtered[activeAirline.selectedCabin].length" @click="showMore">Show more</div>
    </div> -->

    <div class="empty-box d-flex" v-if="!activeAirline.filtered[activeAirline.selectedCabin].length">
      <div v-if="filters.loading || activeAirline.loading.indexOf(activeAirline.selectedCabin) > -1 || appLoader" class="d-flex align-center">
        <i class="fas fa-spinner fa-spin fa-3x" v-if="!appLoader"></i>
        Checking flights...
      </div>
      <div v-else-if="!filters.loading" class="d-flex align-center">
        <i class="fas fa-search fa-fw fa-3x"></i>
        <div>
          No flights found.
          <span class="sub">Try searching for different dates or destination.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
const request = require('browser-request')
// const airportTimezone = require('airport-timezone')
import moment from 'moment-timezone'
import FlightOption from './FlightOption'
import xcurrency from '@/modules/api/currency'
import trackError from '@/modules/api/track-error'
import flightPrice from '@/modules/api/flight-price'
import flightGroundQuote from '@/modules/api/flight-ground-quote'
import servicePrice from '@/modules/api/service-price'

export default {
  name: 'services',
  components: { FlightOption },
  data () {
    return {
      showingFlightOptions: '',
      queue: [],
      flightOptionScroll: {
        active: 0,
        style: 0
      },
      scrollDelay: false
    }
  },
  computed: {
    booking () { return this.$store.state.booking },
    filters () { return this.booking.filters },
    airlines () { return this.booking.airlines },
    locations () { return this.booking.locations },
    activeLeg () { return this.booking.activeLeg },
    selected () { return this.booking.selected },
    leg1Selected () { return this.selected.leg1 },
    leg2Selected () { return this.selected.leg2 },
    activeAirline () { return this.airlines[this.activeLeg] },
    isReturning () { return this.filters.departure.isReturning },
    other () { return this.$store.state.other },
    currency () { return this.other.currency },
    appLoader () { return this.other.appLoader },
    _rtConfirm () { return this.booking.rtConfirm.activate },
    servicesPage () { return this.booking.servicesPage },
    totalPrice () {
      let total = 0
      if (!Object.keys(this.leg1Selected).length || (this.isReturning && !Object.keys(this.leg2Selected).length)) return ''
      if (Object.keys(this.selected.leg1).length) total += this.selected.leg1.payment.totalWithMarkUp
      if (this.filters.departure.isReturning && Object.keys(this.selected.leg2).length) total += this.selected.leg2.payment.totalWithMarkUp
      return total
    },
    apiType () { return this.booking.apiType },
    settings () { return this.booking.settings },
    leg1Discount () { return this.settings.groundLeg1 },
    leg2Discount () { return this.settings.groundLeg2 },
    leg3Discount () { return this.settings.groundLeg3 },
    leg4Discount () { return this.settings.groundLeg4 }
  },
  methods: {
    changeActiveLeg (leg) {
      let tmp = {}
      tmp[leg] = {}
      if (leg === 'leg1') tmp.leg2 = {}
      this.$store.commit('booking/setSelectedData', tmp)
      this.$store.commit('booking/setOthersData', {activeLeg: leg, servicesPage: 10})
    },
    priceFormat (data) {
      return parseFloat(data.toFixed(2)).toLocaleString('en-US')
    },
    countStop (data) {
      if (data.length === 1) return 'Direct Flight'
      return `${data.length - 1} Stop${data.length > 2 ? 's' : ''}`
    },
    countTime (x) {
      x = parseInt(x)
      if (x < 60) return `${x}mins`
      let hour = Math.floor(x / 60)
      return `${hour}h ${x - (hour * 60)}m`
    },
    countDuration (data) {
      let time = 0
      data.forEach(x => {
        time += x.duration
        if (x.LayOverTime) time += x.LayOverTime
      })
      let hr = Math.floor(time / 60)
      let mins = time >= 60 ? time % 60 : time
      let label = ''
      if (hr > 0) label = `${hr}h`
      if (mins > 0) label = `${label} ${mins}m`
      return label
    },
    durationFormat (x) {
      let hr = Math.floor(x / 60)
      let mins = x >= 60 ? x % 60 : x
      let label = ''
      if (hr > 0) label = `${hr}h`
      if (mins > 0) label = `${label} ${mins}m`
      return label
    },
    timeFormat (time) {
      return moment(time, 'YYYY-MM-DD HH:mm:ss').format('hh:mmA')
    },
    dateFormat (time) {
      return moment(time, 'YYYY-MM-DD HH:mm:ss').format('MMM DD')
    },
    check (service) {
      let self = this
      if (!service.available ||
        this.activeAirline.loading.indexOf(this.activeAirline.selectedCabin) > -1 ||
        (!this.isReturning && Object.keys(this.leg1Selected).length) ||
        (this.isReturning && Object.keys(this.leg1Selected).length && Object.keys(this.leg2Selected).length && self.settings.customFlight)
      ) return

      if (window.gtag) { // eslint-disable-line
        gtag( // eslint-disable-line
          'event',
          'D2Dservice - Select Flights',
          {value: self.isReturning ? 'Round Trip' : 'Single Ride'}
        )
      }

      let tmpSelected = {}
      tmpSelected[self.activeLeg] = service
      // tmpSelected[self.activeLeg].ground1 = self.airlines[self.activeLeg].selectedCabin
      // tmpSelected[self.activeLeg].ground2 = self.airlines[self.activeLeg].selectedCabin
      self.$store.commit('booking/setSelectedData', tmpSelected)

      let tmpSelectedGround = {}
      tmpSelectedGround[self.activeLeg] = {}
      tmpSelectedGround[self.activeLeg].pickup = self.airlines[self.activeLeg].selectedCabin
      tmpSelectedGround[self.activeLeg].dropoff = self.airlines[self.activeLeg].selectedCabin
      self.$store.commit('booking/setSelectedGroundData', tmpSelectedGround)

      document.getElementById('serviceContent').scrollIntoView()
      if (self.isReturning && self.settings.customFlight) {
        self.$store.commit('booking/setAirlinesLegData', {
          leg: self.activeLeg,
          fields: {token: service.token}
        })

        // if (self.activeLeg === 'leg1' && !Object.keys(self.booking.selected.leg2).length) {
        if (self.activeLeg === 'leg1') {
          self.$store.commit('booking/setOthersData', {activeLeg: 'leg2'})
        } else if (!Object.keys(self.booking.selected.leg1).length) {
          self.$store.commit('booking/setOthersData', {activeLeg: 'leg1'})
        } else {
          self.showingFlightOptions = ''
          // self.confirmChk()
          self.beginCustomBooking()
        }
        return
      }
      self.showingFlightOptions = ''

      self.$store.commit('other/setOtherData', {
        appLoader: true,
        appLoaderMsg: 'Checking...'
      })
      self.reCheckAirport(service)
    },
    beginCustomBooking () {
      this.$store.commit('other/setOtherData', {
        appLoader: true,
        appLoaderMsg: 'Checking...'
      })
      this.reCheckAirport(this.booking.selected.leg1)
    },
    reCheckAirport (service) {
      if (this.other.widgetTab === 'flight') {
        this.queue = []
        this.queue.push('flightPrice')
        this.processQueue()
        return
      }

      if (this.locations.pickupAirport.code !== service.flight[0].origin.AirportCode) {
        let index = this.booking.airports.findIndex(x => x.code === service.flight[0].origin.AirportCode)
        if (index > -1) {
          this.$store.commit('booking/setLocationsData', {
            pickupAirport: this.booking.airports[index]
          })
          let pIndex = this.booking.nearByAirports.pickup.findIndex(x => x.airport.code === this.booking.airports[index].code)
          if (pIndex === -1) {
            this.$store.commit('booking/addNearyByAirports', {
              field: 'pickup',
              val: {airport: this.booking.airports[index]}
            })
          }
        }
      }
      if (this.locations.dropoffAirport.code !== service.flight[service.flight.length - 1].destination.AirportCode) {
        let index = this.booking.airports.findIndex(x => x.code === service.flight[service.flight.length - 1].destination.AirportCode)
        if (index > -1) {
          this.$store.commit('booking/setLocationsData', {
            dropoffAirport: this.booking.airports[index]
          })
          let dIndex = this.booking.nearByAirports.dropoff.findIndex(x => x.airport.code === this.booking.airports[index].code)
          if (dIndex === -1) {
            this.$store.commit('booking/addNearyByAirports', {
              field: 'dropoff',
              val: {airport: this.booking.airports[index]}
            })
          }
        }
      }

      // Custom Flight - Return Flight Checker
      if (this.isReturning && this.settings.customFlight) {
        let serviceReturn = this.booking.selected.leg2
        if (this.locations.dropoffAirportReturn.code !== serviceReturn.flight[0].origin.AirportCode) {
          let index = this.booking.airports.findIndex(x => x.code === serviceReturn.flight[0].origin.AirportCode)
          if (index > -1) {
            this.$store.commit('booking/setLocationsData', {
              pickupAirportReturn: this.booking.airports[index]
            })
            let pIndex = this.booking.nearByAirports.pickup.findIndex(x => x.airport.code === this.booking.airports[index].code)
            if (pIndex === -1) {
              this.$store.commit('booking/addNearyByAirports', {
                field: 'pickup',
                val: {airport: this.booking.airports[index]}
              })
            }
          }
        }
        if (this.locations.pickupAirportReturn.code !== serviceReturn.flight[serviceReturn.flight.length - 1].destination.AirportCode) {
          let index = this.booking.airports.findIndex(x => x.code === serviceReturn.flight[serviceReturn.flight.length - 1].destination.AirportCode)
          if (index > -1) {
            this.$store.commit('booking/setLocationsData', {
              dropoffAirportReturn: this.booking.airports[index]
            })
            let dIndex = this.booking.nearByAirports.dropoff.findIndex(x => x.airport.code === this.booking.airports[index].code)
            if (dIndex === -1) {
              this.$store.commit('booking/addNearyByAirports', {
                field: 'dropoff',
                val: {airport: this.booking.airports[index]}
              })
            }
          }
        }
      }
      this.getTripDetails()
    },
    getTripDetails () {
      let self = this

      let selected = self.selected
      let leg1 = selected.leg1
      let leg2 = selected.leg2

      self.queue = []
      // self.queue.push(this.locations.pickup.country === 'IND' ? 'pickupGozoQuote' : 'pickupQuote')
      // self.queue.push(this.locations.dropoff.country === 'IND' ? 'dropoffGozoQuote' : 'dropoffQuote')
      self.queue.push('pickupQuote')
      self.queue.push('dropoffQuote')
      if (self.isReturning && self.settings.customFlight) {
        if (leg1.flight[0].origin.AirportCode !== leg2.flight[leg2.flight.length - 1].destination.AirportCode) {
          // self.queue.push(this.locations.dropoff.country === 'IND' ? 'pickupGozoQuoteReturn' : 'dropoffQuoteReturn')
          self.queue.push('dropoffQuoteReturn')
        }
        if (leg1.flight[leg1.flight.length - 1].destination.AirportCode !== leg2.flight[0].origin.AirportCode) {
          // self.queue.push(this.locations.pickup.country === 'IND' ? 'dropoffGozoQuoteReturn' : 'pickupQuoteReturn')
          self.queue.push('pickupQuoteReturn')
        }
      }

      self.queue.push('flightPrice')
      self.$store.commit('other/setOtherData', {
        appLoader: true,
        appLoaderMsg: 'Getting trip details...'
      })
      setTimeout(function () {
        self.processQueue()
      }, 1000)
    },
    processQueue () {
      if (this.queue[0] === 'pickupQuote') {
        this.$store.commit('other/setOtherData', {appLoaderMsg: 'Calculating Ground Transpo...'})
        this.getQuote('pickup', 'leg1')
      }
      if (this.queue[0] === 'dropoffQuote') {
        this.$store.commit('other/setOtherData', {appLoaderMsg: 'Calculating Ground Transpo...'})
        this.getQuote('dropoff', 'leg1')
      }
      if (this.queue[0] === 'pickupQuoteReturn') {
        this.$store.commit('other/setOtherData', {appLoaderMsg: 'Calculating Ground Transpo...'})
        this.getQuote('pickup', 'leg2')
      }
      if (this.queue[0] === 'dropoffQuoteReturn') {
        this.$store.commit('other/setOtherData', {appLoaderMsg: 'Calculating Ground Transpo...'})
        this.getQuote('dropoff', 'leg2')
      }

      if (this.queue[0] === 'pickupGozoQuote') {
        this.$store.commit('other/setOtherData', {appLoaderMsg: 'Calculating Ground Transpo...'})
        this.getGozoQuote('pickup', 'leg1')
      }
      if (this.queue[0] === 'dropoffGozoQuote') {
        this.$store.commit('other/setOtherData', {appLoaderMsg: 'Calculating Ground Transpo...'})
        this.getGozoQuote('dropoff', 'leg1')
      }
      if (this.queue[0] === 'pickupGozoQuoteReturn') {
        this.$store.commit('other/setOtherData', {appLoaderMsg: 'Calculating Ground Transpo...'})
        this.getGozoQuote('pickup', 'leg2')
      }
      if (this.queue[0] === 'dropoffGozoQuoteReturn') {
        this.$store.commit('other/setOtherData', {appLoaderMsg: 'Calculating Ground Transpo...'})
        this.getGozoQuote('dropoff', 'leg2')
      }

      if (this.queue[0] === 'flightPrice') {
        this.getFlightPrice()
        return
      }
      if (!this.queue.length) {
        this.$store.commit('other/setOtherData', {
          appLoader: false,
          appLoaderMsg: ''
        })
        if (this.isReturning && this.other.widgetTab !== 'flight') {
          this.countTotalDiscount()
          return
        }
      }
    },
    getQuote (field, leg, extraData = null) {
      let self = this
      let pickupDate = this.filters.departure.date
      if (field === 'pickup') {
        pickupDate = this.booking.selected[leg].flight[0].origin.DateTime
        pickupDate = pickupDate.split(' ')[0]
      } else {
        pickupDate = this.booking.selected[leg].flight[this.booking.selected[leg].flight.length - 1].destination.DateTime
        pickupDate = pickupDate.split(' ')[0]
      }
      let quoteData = {
        pickupDate: pickupDate,
        leg: leg,
        brandId: self.$store.state.brandId,
        order: 'priority',
        asap: false,
        d2dflight: 1,
        discountCode: self.$store.state.discountCode.code
      }
      let origin = field === 'pickup' ? self.locations.pickup : self.locations.dropoffAirport
      let destination = field === 'pickup' ? self.locations.pickupAirport : self.locations.dropoff
      if (leg === 'leg2') {
        origin = field === 'pickup' ? self.locations.dropoff : self.locations.dropoffAirportReturn
        destination = field === 'pickup' ? self.locations.pickupAirportReturn : self.locations.pickup
      }
      quoteData.pickup = {
        lat: origin.lat,
        lng: origin.lng,
        country: origin.country,
        state: origin.state,
        title: origin.title
      }
      quoteData.dropoff = {
        lat: destination.lat,
        lng: destination.lng,
        country: destination.country,
        state: destination.state,
        title: destination.title
      }

      // GozoCabs
      // if (origin.country === 'IND') {
      //   quoteData.pickup.text = origin.title || origin.name
      //   quoteData.dropoff.text = destination.title || destination.name
      //   quoteData.dynamicTime = false
      //   quoteData.tripType = 1

      //   let eta = extraData && extraData.eta ? extraData.eta : 0
      //   let btt = Math.ceil(eta * 1.15)
      //   let selected = this.booking.selected[leg]
      //   let isDomestic = false
      //   let originFlight = airportTimezone.find(x => x.code === selected.flight[0].origin.AirportCode)
      //   let destinationFlight = airportTimezone.find(x => x.code === selected.flight[0].destination.AirportCode)
      //   let timeVar = 0
      //   if (field === 'dropoff') {
      //     originFlight = airportTimezone.find(x => x.code === selected.flight[selected.flight.length - 1].origin.AirportCode)
      //     destinationFlight = airportTimezone.find(x => x.code === selected.flight[selected.flight.length - 1].destination.AirportCode)
      //   }
      //   if (originFlight && destinationFlight && originFlight.countryCode === destinationFlight.countryCode) {
      //     isDomestic = true
      //   }
      //   if (field === 'pickup') {
      //     timeVar = parseFloat(this.booking.settings[isDomestic ? 'departureBufferDomestic' : 'departureBufferInternational'])
      //     let date = moment(selected.flight[0].origin.DateTime, 'YYYY-MM-DD HH:mm:ss')
      //     date.subtract(timeVar + btt, 'minutes')
      //     quoteData.pickupTimestamp = date.format('X')
      //   } else {
      //     timeVar = parseFloat(this.booking.settings[isDomestic ? 'arrivalBufferDomestic' : 'arrivalBufferInternational'])
      //     let date = moment(selected.flight[selected.flight.length - 1].destination.DateTime, 'YYYY-MM-DD HH:mm:ss')
      //     date.add(timeVar, 'minutes')
      //     quoteData.pickupTimestamp = date.format('X')
      //   }
      // }

      flightGroundQuote.getQuote(self, field, leg, quoteData, res => {
        if (!res) {
          self.queue = []
          return
        }
        self.queue.shift()
        self.processQueue()
      })
    },
    getGozoQuote (field, leg, eta = null) {
      if (!eta) {
        this.getEta(field, leg)
        return
      }
      let tmp = {eta: eta}
      this.getQuote(field, leg, tmp)
    },
    getEta (field, leg) {
      let self = this
      let url = 'https://router.hereapi.com/v8/routes?apiKey={API_KEY}&origin={ORIGIN}&destination={DESTINATION}&transportMode=car&return=polyline,summary'
      let origin = field === 'pickup' ? self.locations.pickup : self.locations.dropoffAirport
      let destination = field === 'pickup' ? self.locations.pickupAirport : self.locations.dropoff
      if (leg === 'leg2') {
        origin = field === 'pickup' ? self.locations.dropoff : self.locations.dropoffAirportReturn
        destination = field === 'pickup' ? self.locations.pickupAirportReturn : self.locations.pickup
      }
      url = url.replace('{API_KEY}', CONFIG.hereApi.key)
        .replace('{ORIGIN}', encodeURIComponent(origin.lat + ',' + origin.lng))
        .replace('{DESTINATION}', encodeURIComponent(destination.lat + ',' + destination.lng))

      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err || (body.routes && !body.routes.length)) {
          self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
          self.$store.commit('global/setAlertData', {show: true, message: res.error.message})
          let tmpRes = err || 'Route not found'
          trackError.track(self, {
            type: 'calculate_eta',
            data: {
              main_pickup: self.locations.pickup,
              main_dropoff: self.locations.dropoff,
              request: {
                url: url,
                payload: ''
              },
              response: tmpRes
            }
          })
          return
        }
        if (body.routes && body.routes.length) {
          let driverETA = 0
          body.routes[0].sections.forEach(route => {
            driverETA += Math.round(route.summary.duration / 60)
          })
          self.getGozoQuote(field, leg, driverETA)
          return
        }
      })
    },
    getFlightPrice () {
      this.queue.shift()

      // PROCEED to ITINERARY Page and load the /flight-price there
      // if (this.other.widgetTab === 'flight') {
      this.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
      flightPrice.get(this, 'leg1')
      this.$router.push('d2ditinerary')
        // return
      // }

      // SHOW LOADER and wait for /flight-price
      // this.$store.commit('other/setOtherData', {
      //   appLoader: true,
      //   appLoaderMsg: 'Getting flight details...'
      // })
      // flightPrice.get(this, 'leg1')
    },
    addMarkUp (x) {
      x = parseFloat(x)
      let tmp = x + (x * this.booking.settings.markUpPercent)
      tmp = parseFloat(tmp.toFixed(2))
      return this.priceFormat(tmp)
    },
    applyCurrency (x, useSymbol = true, noComma = false) {
      x = x.toString().replace(/[',']/g, '')
      x = parseFloat(x)
      x = x * this.currency.value
      if (!useSymbol) return parseFloat(x.toFixed(2))
      return xcurrency.format({
        code: this.currency.code,
        val: x.toFixed(2)
      }, useSymbol, noComma)
    },
    sendQuoteTime (start, end, quoteId, param) {
      let self = this
      let store = self.$store.state
      let duration = end.diff(start, 'milliseconds') / 1000
      self.$sdk.opt('/quotation/time', {
        token: store.user.token,
        brandId: store.brandId,
        quotationId: quoteId,
        responseTime: duration,
        deviceType: 'ww',
        data: JSON.stringify(param)
      }, res => {
        if (res.error) console.log('ERROR quotation time')
      })
    },
    reconvertCurrency (x, code) {
      let currRate = this.currency.list[code]
      x = parseFloat(x.toFixed(2))
      x = parseFloat((x / currRate).toFixed(2))
      return x
    },
    otherLegPrice () {
      return servicePrice.otherLegPrice(this, this.activeLeg)
    },
    confirmChk () {
      if (this.isReturning && this.activeLeg === 'leg2') {
        this.$store.commit('booking/setRtConfirmData', {show: true})
        return
      }
      // this.check(service)
    },
    showMore () {
      this.$store.commit('booking/setOthersData', {servicesPage: this.servicesPage + 10})
    },
    continueToItinerary () {
      if (!Object.keys(this.leg1Selected).length || (this.isReturning && !Object.keys(this.leg2Selected).length)) return

      this.beginCustomBooking()
      // if (this.isReturning) this.confirmChk()
      // else {
      //   this.$store.commit('other/setOtherData', {
      //     appLoader: true,
      //     appLoaderMsg: 'Checking...'
      //   })
      //   this.reCheckAirport(this.leg1Selected)
      // }
    },
    foScroll (dir, max) {
      let boxSize = 270 // width of .fo-box
      let gap = 15

      if (dir === 'left' && this.flightOptionScroll.active !== 0) this.flightOptionScroll.active--
      if (dir === 'right' && this.flightOptionScroll.active !== (max - 1)) this.flightOptionScroll.active++

      let active = this.flightOptionScroll.active
      let value = (boxSize * active) + (gap * (active - 1))
      this.flightOptionScroll.style = value <= 0 ? 0 : value
    },
    cabinLabel (x) {
      if (x === 'PremiumEconomy') return 'Premium Economy'
      return x
    }
  },
  watch: {
    _rtConfirm (val) {
      if (val) {
        this.$store.commit('booking/setRtConfirmData', {activate: false})
        this.beginCustomBooking()
      }
    },
    showingFlightOptions () {
      this.flightOptionScroll = {
        active: 0,
        style: 0
      }
    }
  },
  mounted () {
    document.addEventListener('wheel', function (e) {
      let slider = e.target.closest('.flight-options')
      if (slider) {
        slider.scrollBy({
          left: e.deltaY < 0 ? -50 : 50,
          behavior: 'smooth'
        });
      }
    })

    let self = this
    let widget = document.getElementById('bookingForm') || document.getElementById('app')

    if (CONFIG.Env === 'development') {
      window.addEventListener('scroll', function () {
        if (self.$route.name !== 'D2DService') return
        let widgetHeight = document.getElementById('app').scrollHeight
        let screenHeight = window.innerHeight
        let scrollY = window.scrollY

        if (scrollY >= widgetHeight - screenHeight - 400) {
          if (!self.scrollDelay) {
            self.scrollDelay = true
            self.showMore()
            setTimeout(() => {
              self.scrollDelay = false
            }, 1400)
          }
        }
      })
    } else {
      widget.addEventListener('scroll', function () {
        if (self.$route.name !== 'D2DService') return
        let widgetHeight = widget.scrollHeight
        let screenHeight = window.innerHeight
        let scrollY = widget.scrollTop

        if (scrollY >= widgetHeight - screenHeight - 400) {
          if (!self.scrollDelay) {
            self.scrollDelay = true
            self.showMore()
            setTimeout(() => {
              self.scrollDelay = false
            }, 1400)
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$screen-medium: 64em;
$screen-small: 40em;

.d2d-services-box{
  padding-left: 20px;

  &.loading{
    .d2d-service{
      opacity: .6;
    }
  }

  @media only screen and (max-width: $screen-small) {
    padding: 0;
  }
}

.service-head{
  letter-spacing: .5px;

  .sh-nav{
    gap: 20px;
    color: #707f8f;
    overflow-x: auto;
    white-space: nowrap;
    align-items: center;
    display: flex;
    margin-bottom: 20px;
    padding: 5px 2px;

    .sh-nav-item{
      display: inline-block;
      vertical-align: top;
    }
    .sh-box{
      border: 1px solid #bbb;
      padding: 10px;
      border-radius: 3px;

      &.active{
        border: 1px solid #edb545;
        outline: 2px solid #edb545;
      }
    }
    .default-txt{
      font-size: 21px;
      line-height: 45px;
      &.active{
        font-weight: 600;
        color: #191f24;
        background-size: 300% 400%;
      }
      &:hover{
        background: #fffdfa;
      }
    }
    .sh-selected-top{
      line-height: 1;
      margin-bottom: 5px;
      gap: 20px;
    }
    .sh-airport{
      margin-right: 10px;
      color: #2c3e50;
    }
    .change-flight{
      font-size: 13px;
      color: #3C8CE1!important;
      font-weight: 600;
      line-height: 1;
      cursor: pointer;
    }
    .sh-selected-bottom{
      gap: 20px;
      font-size: 14px;
      img{
        height: 20px;
        margin-right: 5px;
      }
    }
    .sh-airline{
      text-transform: capitalize;
    }
    .sh-price{
      font-weight: 600;
      color: #2c3e50;
    }
    .fa-chevron-right{
      line-height: 50px;
      margin: 0 5px;
    }
    .sh-continue{
      gap: 10px;
    }
    .sh-total-price{
      line-height: 1;
      div{
        color: #6c7c8f;
        font-size: 12px;
        letter-spacing: .5px;
        margin-bottom: 2px;
        line-height: 1;
      }
      span{
        font-size: 18px;
        font-weight: 600;
        line-height: 1;
        color: #333;
      }
    }
    .continue-btn{
      font-size: 18px;
      font-weight: 600;
      padding: 10px 15px;
      &.disabled{
        color: #bbb;
      }
      &.active{
        animation: glow .5s infinite alternate;
      }
    }
  }

  .sort-line{
    gap: 20px;
    margin-bottom: 20px;
    font-size: 21px;

    .sl-txt{
      font-size: 13px;
      color: #555;
    }
    .rd-field-box{
      border: 2px solid #CCD0E2;
      border-radius: 4px;
      line-height: 1;
      padding: 7px 10px 10px;
      margin-bottom: 6px;

      label{
        display: block;
        color: #6c7c8f;
        font-size: 12px;
        margin-bottom: 2px;
      }
      select{
        padding: 0;
        width: 180px;
        border: none;
        outline: none;
        font-size: 17px;
        line-height: 1;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }
}
@keyframes highlight{
  0%, 100%{ background-position: 0 0; }
  50%{ background-position: 100% 100%; }
}
@keyframes glow {
  from { box-shadow: 0 0 2px -2px #f8cf71; }
  to { box-shadow: 0 0 2px 2px #efbb43; }
}

.d2d-service{
  border: 1px solid #B3B3B5;
  background: #fff;
  margin-bottom: 15px;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;

  &:hover{
    border: 1px solid #d1b47c;
    box-shadow:0 0 3px rgba(0,0,0, .5);
  }
  &.selected{
    outline: 2px solid #ecae20;
  }
  &.not-available, &.disabled{
    opacity: .6;
  }
  &.showing-opt{
    background: #f8f8f8;
  }
}
.flight-faretype{
  line-height: 1;
  padding: 7px 10px;
  letter-spacing: .6px;
  font-size: 14px;
  color: #444;

  label{
    margin-right: 8px;
  }
}

.flight-options-box{
  overflow: hidden;
  position: relative;
}
.f-prev-next{
  top: calc(50% - 25px);
  position: absolute;
  z-index: 2;
  background: #fff;
  border: 1px solid #ecae20;
  padding: 7px 5px;
  line-height: 1;
  border-radius: 3px;
  font-size: 25px;
  color: #ecae20;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, .5);
  
  &.fa-chevron-left{
    left: 0;
  }
  &.fa-chevron-right{
    right: 0;
  }
  &.disabled{
    opacity: .7;
    border-color: #999;
    color: #999;
    cursor: default;
  }
}
.flight-options{
  padding: 0 15px 20px;
  width: 100%;
  display: flex;
  gap: 15px;
  position: relative;
  z-index: 1;
  transition: all .2s ease;
  // overflow-x: auto;
  // scroll-snap-type: x mandatory;
  // scroll-padding: 15px;
}
.fo-box{
  border: 1px solid #abb2b8;
  border-radius: 6px;
  padding: 10px;
  background: #fff;
  max-width: 250px;
  flex: 0 0 250px;
  scroll-snap-align: start;

  &.unavailable{
    opacity: .6;

    .lr-btn{
      cursor: default;
    }
  }
}
.fo-price{
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 5px;
  
  span{
    margin-left: 3px;  
  }
}
.fo-cabin{
  background: #fbefd2;
  padding: 7px 15px;
  font-weight: 600;
  color: #8e651a;
  font-size: 14px;
  margin-bottom: 15px;
  border-radius: 20px;
  display: inline-block;
  letter-spacing: .6px;
  line-height: 1;
}
.fo-info{
  list-style: none;
  padding: 0 0 0 5px;
  margin: 0 0 30px;

  li{
    font-size: 14px;
    vertical-align: -1px;
    line-height: 1;

    &:not(:last-child){
      margin-bottom: 15px;
    }
  }
  i{
    margin-right: 5px;
    font-size: 18px;
    color: #5e6e7f;
  }
  .fa-suitcase-rolling{
    margin-right: 8px;

    &:not(.not-allowed){
      color: #1ea31c;
    }
  }
  .fa-dollar-sign{
    font-size: 11px;
    border: 1px solid #1ea31c;
    padding: 4px 6px;
    color: #1ea31c;
    border-radius: 100%;
    margin-right: 3px;
  }
}
.select-btn{
  letter-spacing: 1.5px;
  border-radius: 20px;
  font-size: 15px;
}

.flight-details{
  text-align: center;
  width: 100%;
  gap: 15px;
  padding: 20px 10px;

  .fl-details {
    height: 65px;
  }
  .fd-logo{
    flex: 0 0 65px;
  }
  img{
    margin-right: 10px;
    width: 65px;
    height: 65px;
  }
  .cancel-options{
    display: block;
    width: 65px;
    cursor: pointer;
    letter-spacing: .5px;
  }
  .flight-date{
    min-width: 100px;
    b.time {
      font-size: 16px;
    }
    .date{
      font-size: 14px;

      span{
        display: inline-block;
        margin:0 3px;
      }
    }
  }
  .flight-duration{
    width: 100%;
    .duration {
      font-size: 14px;
    }
    hr{
      margin: 0;
      width: 100%;
    }
    b{
      margin-right: 6px;
    }
  }
}
.flight-layover{
  text-align: center;
  color: #888;
  font-size: 14px;
  line-height: 1;
  margin-top: 3px;
  letter-spacing: .3px;
}
.flight-price{
  width: 180px;
  text-align: right;
  padding: 20px 10px;

  .price{
    font-weight: 600;
    font-size: 23px;
    line-height: 1;
    margin: 5px 0 2px;

    span{
      white-space: nowrap;
    }
  }
  .per-traveler{
    font-size: 12px;
    letter-spacing: .5px;
    color: #444;
  }
  .op-btn{
    font-size: 15px;
  }
}
.mob-airline-logo{
  display: none;

  img{
    height: 100px;
    width: fit-content;
    margin: 0 auto;
  }
}

.duration{
  text-align: center;
  color: #888;
  font-size: 14px;
  line-height: 1;
  margin-top: 10px;
}

.show-more{
  background: #ECAE20;
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  letter-spacing: .6px;
  padding: 15px 50px;
  margin: 30px auto;
  display: inline-block;
  border-radius: 30px;
  cursor: pointer;

  &:hover{
    background: #c58f15;
  }
}

.empty-box{
  font-size: 24px;
  height: calc(100vh - 70px);
  align-items: center;

  div{
    padding-left: 10px;
  }
  .fas{
    margin-right: 15px;
  }
  .sub{
    display: block;
    font-size: 18px;
    color: #9a9ca6;
    font-style: italic;
  }
}

.service-mobile{
  display: none;
  width: 100%;
  border: 1px solid #B3B3B5;
  padding: 15px;
  border-radius: 6px;
  letter-spacing: .5px;

  .s-mob-header{
    margin-bottom: 20px;

    img{
      height: 64px;
    }
  }
  .price{
    font-size: 21px;
    font-weight: 600;
    text-align: right;
  }
  .per-traveler{
    font-size: 12px;
    letter-spacing: .5px;
    color: #444;
    text-align: right;
  }
  .select-flight{
    width: 100%;
    font-size: 18px;
    padding: 16px 40px;
  }
}
.serv-mob-details{
  // width: calc(100% - 200px);
  line-height: 1;
  margin-bottom: 20px;

  img{
    width: 50px;
  }
  .flight-time{
    gap: 10px;
    margin-top: 6px;
    margin-bottom: 10px;

    span{
      font-size: 18px;
      font-weight: 600;
    }
  }
  hr{
    width: 100%;
    display: inline-block;
    border-top-color: #5E6E7F;
    border-bottom: none;
    max-width: 100px;
    vertical-align: -2px;
    margin-left: 15px;
    margin-right: 15px;
  }
  .airport-row{
    color: #5E6E7F;
    font-size: 14px;
    margin-bottom: 10px;
    gap: 10px;

    span{
      white-space: nowrap;
    }
  }
}
.serv-mov-duration{
  gap: 10px;
  margin-bottom: 10px;
}

@media only screen and (max-width: 639px) {
  .hide-in-mobile{
    display: none;
  }

  .d2d-service-mobile{
    flex-direction: column;
  }
  .mob-airline-logo{
    display: flex;
  }
  .fl-details{
    padding: 0 5px;
    height: auto !important;
    min-height: 65px;
    max-height: 80px;
    margin-bottom: 15px;

    img{
      display: none;
    }
  }
  .flight-details {
    padding: 0 5px;

    .flight-date{
      min-width: 90px;
    }
  }
  .flight-duration{
    padding: 0 10px;
    font-size: 14px;
  }
  .flight-price{
    width: 100%;
    border-left: 0;
    border-top: 2px solid #ccc;
  }

  .service-head{
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .sort-line{
    order: 1;
    .rd-field-box{
      display: none;
    }
  }
  .sh-nav{
    order: 2;
    gap: 5px !important;
    margin-bottom: 15px;
    padding-bottom: 10px;
    overflow-x: scroll;

    .default-txt{
      line-height: 45px !important;
      font-size: 16px!important;
      white-space: nowrap;
    }
    .fa-chevron-right{
      line-height: 1!important;
    }
  }

  .service-mobile{
    display: block;
  }

  .flight-options{
    padding: 10px;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    scroll-padding: 15px;
  }

  .flight-layover{
    text-align: left;
  }
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all .15s ease-in-out;
  transition-delay: calc(150ms * var(--i));
}
.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// Services.vue?5743051d